// removed by extract-text-webpack-plugin
module.exports = {"main":"App__main___3aFTN"};


//////////////////
// WEBPACK FOOTER
// ./modules/App.css
// module id = 643
// module chunks = 0